<template>
  <div class="tile-container">
    <div id="aktivitaet-bearbeiten-modal" class="modal fade">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <ValidationObserver v-slot="{ invalid }">
            <div class="modal-header">
              <modal-close-button-new @confirmed="closeModal" />
              <h4 class="modal-title">
                {{
                  aktivitaet.id
                    ? $t("global.editpending")
                    : $t("global.addpending")
                }}
              </h4>
            </div>
            <div class="modal-body table-wrapper" style="max-height: 500px">
              <div v-if="kontaktbasiert === null">
                <div class="txtTrsf">
                  {{ $t("global.whatkindofpendingissue") }}
                </div>
                <div class="row">
                  <div class="col-xl-6">
                    <div class="form-group">
                      <button class="btn btnTrsf" @click="unsetKontaktbasiert">
                        {{ $t("global.personalpending") }}
                      </button>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <button class="btn btnTrsf" @click="setKontaktbasiert">
                        {{ $t("global.contactbasedpending") }}
                      </button>
                    </div>
                  </div>
                </div>
              </div>
              <div v-if="kontaktbasiert !== null">
                <div class="row">
                  <div class="col-xl-6">
                    <!-- <button class="btn btnBack" @click="unsetAuswahl">
                      <font-awesome-icon
                        icon="fa-solid fa-arrow-left"
                        size="lg"
                      />
                      <span> {{ $t("global.changekindofpending") }}</span>
                    </button> -->
                  </div>
                  <div class="col-xl-6">
                    <single-select-person
                      id="aktivitaet-person"
                      :person="kontaktPerson"
                      :firma="kontaktFirma"
                      :label="$t('global.contactperson')"
                      :required="false"
                      editable
                      :allowOpen="false"
                      @confirmed="setPerson"
                      :tabindex="1"
                      :remove="true"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <ValidationProvider
                        rules="required"
                        immediate
                        v-slot="{ passed }"
                      >
                        <input
                          v-model.trim="aktivitaet.bezeichnung"
                          v-bind:class="{ 'border-danger': !passed }"
                          class="form-control"
                        />
                        <label v-bind:class="{ 'text-danger': !passed }">
                          {{ $t("global.pendingname") }}*
                        </label>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-3">
                    <div class="form-group">
                      <div class="input-group">
                        <input
                          type="date"
                          class="form-control"
                          v-model="geplantdatum"
                          @change="checkAktDatum()"
                          :class="pastDate ? 'text-danger' : ''"
                          v-tooltip.hover="
                            pastDate
                              ? (text = $t('global.planneddatebeforetoday'))
                              : (text = '')
                          "
                        />
                      </div>
                      <label>{{ $t("global.planneddate") }}</label>
                    </div>
                  </div>
                  <div v-if="geplantdatum" class="col-xl-3">
                    <div class="form-group">
                      <div class="input-group">
                        <input
                          type="time"
                          class="form-control"
                          v-model="aktivitaet.geplantzeit"
                        />
                        <div
                          class="input-group-append text-medium-light h-100 mr-2 d-flex align-items-center"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-clock"
                            class="m-auto"
                          />
                        </div>
                      </div>
                      <label>{{ $t("global.plannedtime") }}</label>
                    </div>
                  </div>
                  <div class="col-xl-3">
                    <div class="form-group">
                      <div class="input-group">
                        <input
                          type="date"
                          class="form-control"
                          v-model="effektivdatum"
                          @change="checkGeplantdatum()"
                          :class="pastPlannedDate ? 'text-danger' : ''"
                          v-tooltip.hover="
                            pastPlannedDate
                              ? (text = $t('global.effectivedatebeforeplanned'))
                              : (text = '')
                          "
                        />
                      </div>
                      <label>{{ $t("global.effectivedate") }}</label>
                    </div>
                  </div>
                  <div v-if="effektivdatum" class="col-xl-3">
                    <div class="form-group">
                      <div class="input-group">
                        <input
                          type="time"
                          class="form-control"
                          v-model="aktivitaet.effektivzeit"
                        />
                        <div
                          class="input-group-append text-medium-light h-100 mr-2 d-flex align-items-center"
                        >
                          <font-awesome-icon
                            icon="fa-solid fa-clock"
                            class="m-auto"
                          />
                        </div>
                      </div>
                      <label>{{ $t("global.effectivetime") }}</label>
                    </div>
                  </div>
                </div>
                <div
                  class="row"
                  v-if="
                    (neueAktivitaet && kontaktbasiert) ||
                    (!neueAktivitaet && aktivitaet.prozess?.id)
                  "
                >
                  <span v-if="neueAktivitaet" class="mx-3 mb-3 mt-4">{{
                    $t("global.processcanbechangedafterwards")
                  }}</span>
                  <span v-else class="mx-3 mb-3 mt-4">{{
                    $t("global.processcannotbechanged")
                  }}</span>
                  <div class="col-xl-12">
                    <div class="form-group">
                      <v-select
                        v-model="aktivitaet.prozess"
                        label="bezeichnung"
                        :options="prozesse"
                        :placeholder="$t('global.Process')"
                        :reduce="(el) => el.id"
                        :disabled="!neueAktivitaet"
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.Process") }}</label>
                    </div>
                  </div>
                  <!-- <div class="col-xl-6">
                    <div class="form-group">
                      <v-select
                        v-model="aktivitaet.prozesslauf"
                        label="bezeichnung"
                        :options="prozesslaeufe"
                        placeholder="Prozesslauf"
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>Prozesslauf</label>
                    </div>
                  </div> -->
                </div>
                <div class="row">
                  <div
                    class="col-xl-6"
                    v-if="
                      (neueAktivitaet && hofRequired) ||
                      Object.keys(hof).length > 0
                    "
                  >
                    <single-select-firma
                      id="aktivitaet-firma"
                      :firma="hof"
                      :editable="neueAktivitaet"
                      :allowOpen="false"
                      :label="
                        hofRequired
                          ? $t('global.farm') + '*'
                          : $t('global.farm')
                      "
                      @confirmed="setHof"
                      :required="hofRequired"
                    />
                  </div>
                  <div
                    class="col-xl-6"
                    v-if="
                      (neueAktivitaet && jugEinsatzRequired) ||
                      Object.keys(jugendlicher).length > 0
                    "
                  >
                    <single-select-person
                      id="aktivitaet-person"
                      :person="jugendlicher"
                      :label="
                        jugEinsatzRequired
                          ? $t('global.youth') + '*'
                          : $t('global.youth')
                      "
                      :editable="neueAktivitaet"
                      :allowOpen="false"
                      @confirmed="setJugendlicher"
                      :required="jugEinsatzRequired"
                    />
                  </div>
                </div>
                <div class="row">
                  <div
                    class="col-xl-6"
                    v-if="neueAktivitaet && jugEinsatzRequired"
                  >
                    <single-select-angebot
                      :angebot="angebot"
                      :label="
                        jugEinsatzRequired
                          ? $t('global.offer') + '*'
                          : $t('global.offer')
                      "
                      :editable="neueAktivitaet"
                      @confirmed="setAngebot"
                      :required="jugEinsatzRequired"
                    />
                  </div>
                  <div
                    class="col-xl-6"
                    v-if="(neueAktivitaet && jugEinsatzRequired) || einsatzId"
                  >
                    <div class="form-group">
                      <ValidationProvider
                        :rules="jugEinsatzRequired ? 'required' : ''"
                        immediate
                        v-slot="{ passed }"
                      >
                        <v-select
                          v-model="einsatzId"
                          :class="{
                            'border rounded border-danger': !passed,
                          }"
                          label="von"
                          :options="einsaetze"
                          :placeholder="
                            !angebot.id
                              ? $t('global.selectoffer')
                              : einsaetze.length === 0
                              ? $t('global.nodeployments')
                              : $t('global.deployment')
                          "
                          :reduce="(el) => el.id"
                          :disabled="!neueAktivitaet"
                        >
                          <template #option="{ von, bis, person }">
                            {{ von }} –
                            {{ bis + ", " + person.personName }}
                          </template>

                          <template #selected-option="{ von, bis, person }">
                            {{ von }} –
                            {{ bis + ", " + person.personName }}
                          </template>

                          <span slot="no-options">{{
                            $t("global.taptosearch")
                          }}</span>
                        </v-select>
                        <label v-bind:class="{ 'text-danger': !passed }">
                          {{
                            jugEinsatzRequired
                              ? $t("global.deployment") + "*"
                              : $t("global.deployment")
                          }}
                        </label>
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div class="row">
                  <div v-if="aktivitaet.prozess == null" class="col-xl-6">
                    <div class="form-group">
                      <v-select
                        v-model="aktivitaet.typ"
                        :class="{
                          'border rounded border-danger': !passed,
                        }"
                        label="bezeichnung"
                        :options="typen"
                        :tabindex="6"
                        :placeholder="$t('global.type')"
                        :disabled="aktivitaet.prozess != null"
                      >
                        <span slot="no-options">{{
                          $t("global.taptosearch")
                        }}</span>
                      </v-select>
                      <label>{{ $t("global.type") }}</label>
                    </div>
                  </div>
                  <div class="col-xl-6">
                    <div class="form-group">
                      <ValidationProvider
                        rules="required"
                        immediate
                        v-slot="{ passed }"
                      >
                        <v-select
                          v-model="aktivitaet.status"
                          :class="{
                            'border rounded border-danger': !passed,
                          }"
                          label="bezeichnung"
                          :options="stati"
                          :tabindex="7"
                          :placeholder="$t('global.status')"
                        >
                          <span slot="no-options">{{
                            $t("global.taptosearch")
                          }}</span>
                        </v-select>
                        <label v-bind:class="{ 'text-danger': !passed }">
                          {{ $t("global.status") }}*</label
                        >
                      </ValidationProvider>
                    </div>
                  </div>
                </div>
                <div v-if="kontaktbasiert" class="row">
                  <div class="col-xl-4">
                    <single-select-firma
                      id="aktivitaet-firma"
                      :firma="kontaktFirma"
                      :editable="true"
                      :allowOpen="true"
                      :label="$t('global.responsibleswitchingcentre')"
                      @confirmed="setFirma"
                      :filterPerson="verantwortlicher[0]"
                    />
                  </div>
                  <div class="col-xl-8">
                    <multi-select-person
                      id="aktivitaet-verantwortlicher"
                      :personen="verantwortlicher"
                      :label="$t('global.responsiblepersons')"
                      editable
                      :open="false"
                      @confirmed="setVerantwortlicher"
                      :tabindex="8"
                      :firma="kontaktFirma"
                      @updatefirma="setFirma"
                      :remove="true"
                    />
                  </div>
                </div>
                <div class="row">
                  <div class="col-xl-12">
                    <div class="form-group">
                      <!-- Dynamische Zusatzinfos über dem Textfeld -->
                      <pre
                        v-if="verlinkteDatensaetze && neueAktivitaet"
                        class="mb-2 text-muted"
                        >{{ verlinkteDatensaetze }}</pre
                      >
                      <ckeditor
                        :editor="editor"
                        v-model="aktivitaet.beschreibung"
                        @blur="aktivitaet.beschreibung = replaceLinks(aktivitaet.beschreibung)"
                      ></ckeditor>
                      <label>{{ $t("global.description") }}</label>
                    </div>
                  </div>
                </div>
                <div v-if="aktivitaet.id && shown" class="row">
                  <div class="col-xl-12 p-0">
                    <div class="tab-container p-3">
                      <dokumentenliste
                        :aktivitaet="aktivitaet.id"
                        :dokumentEditable="shown"
                        :shown="shown"
                        :key="componentKey"
                        @updateComponent="updateDokumentenliste"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button
                v-if="kontaktbasiert !== null"
                type="button"
                class="btn btn-danger"
                :disabled="pendenzenIsBusy"
                @click="oeffneLoeschenModal"
              >
                {{ $t("global.delete") }}
              </button>
              <button type="button" class="btn btn-default" @click="closeModal">
                {{ $t("global.close") }}
              </button>
              <button
                v-if="kontaktbasiert !== null"
                type="button"
                :disabled="invalid || pendenzenIsBusy"
                class="btn btn-primary"
                @click="uebernehmen"
                :title="invalid ? $t('global.notallfieldsfilledcorrectly') : ''"
              >
                {{ $t("global.apply") }}
              </button>
            </div>
          </ValidationObserver>
        </div>
      </div>
    </div>
    <loeschen-modal
      id="pendenzen-loeschen-modal"
      @confirmed="loeschen"
      :multiple="true"
    />
  </div>
</template>

<script>
import ModalCloseButtonNew from "@/components/global/ModalCloseButtonNew";
import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import MultiSelectPerson from "@/components/global/MultiSelectPerson.vue";
import SingleSelectFirma from "@/components/global/SingleSelectFirma.vue";
import Dokumentenliste from "@/components/Reiter/Dokumentenliste";
import LoeschenModal from "@/components/Modals/LoeschenModal";
import SingleSelectAngebot from "@/newviva/components/Global/SingleSelectAngebot.vue";
import AppApi from "@/api/AppApi";
import { apiErrorToAlert } from "@/utils/Errorhandler";
import ClassicEditor from "/custom/custom_ckeditor/build/ckeditor";

import page from "@/mixins/Page";
import { LADE_AUSWAHLWERTE_CRM } from "@/store/crm/actions.type";
import replaceLinks from "@/utils/Text";

export default {
  name: "AktivitaetModalNewViva",
  components: {
    ModalCloseButtonNew,
    LoeschenModal,
    SingleSelectPerson,
    SingleSelectFirma,
    MultiSelectPerson,
    Dokumentenliste,
    SingleSelectAngebot,
  },
  mixins: [page],
  metaInfo() {},
  props: {
    pendenzenIsBusy: {
      type: Boolean,
      default: false,
    },
    isKontaktbasiert: {
      type: Boolean,
      default: false,
    },
    kontakt: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      kontaktPerson: {},
      kontaktFirma: {},
      verantwortlicher: [{ name: this.$t("global.notlinked") }],
      aktivitaet: {
        person: {},
        verantwortlicher: [{ name: this.$t("global.notlinked") }],
        firma: {},
        prozess: null,
        foreignEntity: {},
      },
      neueAktivitaet: false,
      shown: false,
      kontaktbasiert: null,
      geplantdatum: null,
      effektivdatum: null,
      pastDate: false,
      pastPlannedDate: false,
      componentKey: 0,
      isDozent: false,
      leadId: {},
      hof: {},
      jugendlicher: {},
      angebot: {},
      einsaetze: [],
      einsatzId: null,
      editor: ClassicEditor,
    };
  },
  computed: {
    typen() {
      if (this.$store) return this.$store.state.crm.aktivitaettypen;
      return [];
    },
    stati() {
      if (this.$store) return this.$store.state.crm.aktivitaetstati;
      return [];
    },
    prozesse() {
      if (this.$store) return this.$store.state.crm.prozesse;
      return [];
    },
    /*     prozesslaeufe() {
      if (this.$store) return this.$store.state.crm.aktivitaetstati;
      return [];
    }, */

    hofRequired() {
      switch (this.aktivitaet.prozess) {
        // Reservationen
        case "196D2C20B11":
        case "196D2C3F3DF":
        case "1969152B8F6":
        case "196D2C0A283":
          return true;
        // Einsatz
        case "1969152E1C8":
          return false;
        // Bauernregistration
        case "195C895B8CA":
          return true;
        // Ersterfassung
        case "196388EA9C4":
          return true;
        default:
          return false;
      }
    },

    jugEinsatzRequired() {
      switch (this.aktivitaet.prozess) {
        // Reservationen
        case "196D2C20B11":
        case "196D2C3F3DF":
        case "1969152B8F6":
        case "196D2C0A283":
          return true;
        // Einsatz
        case "1969152E1C8":
          return true;
        // Bauernregistration
        case "195C895B8CA":
          return false;
        // Ersterfassung
        case "196388EA9C4":
          return false;
        default:
          return false;
      }
    },
    verlinkteDatensaetze() {
      const hof = Object.keys(this.hof).length
        ? `<p>${this.$t("global.farmname")}: <a href="${
            this.$CONST("CONFIG").BASEURL
          }/app/unternehmen/${this.hof.id}/0">${this.hof.name}</a></p>\n`
        : "";
      const jugendlicher = Object.keys(this.jugendlicher).length
        ? `<p>${this.$t("global.youth")}: <a href="${
            this.$CONST("CONFIG").BASEURL
          }/app/person/${this.jugendlicher.id}/0">${this.jugendlicher.personName}</a></p>\n`
        : "";
      const einsatz = this.einsatzId
        ? `<p>${this.$t("global.deployment")}: <a href="${
            this.$CONST("CONFIG").BASEURL
          }/app/einsatz/${this.einsatzId}">${this.$t("global.deployment")}</a></p>\n`
        : "";
      return hof + jugendlicher + einsatz;
    },
  },
  watch: {},
  created() {
    if (
      this.gruppen.find(
        (gruppe) =>
          gruppe.id == this.$CONST("GRUPPEN").INSTRUCTOR ||
          gruppe.id == "1774DD1D796" // Dozentengruppe
      )
    )
      this.isDozent = true;
  },
  mounted() {
    if (this.typen.length == 0)
      this.$store.dispatch(`crm/${LADE_AUSWAHLWERTE_CRM}`);

    this.$bus.$on("aktivitaet-modal-show", (data) => {
      this.aktivitaet = Object.assign({}, data);

      if (!this.aktivitaet.foreignEntity) {
        this.aktivitaet.foreignEntity = {};
      }

      if (data.neu) {
        if (this.isKontaktbasiert) {
          this.kontaktbasiert = true;
        } else {
          this.kontaktbasiert = null;
        }

        if (this.kontakt) {
          this.verantwortlicher = [this.kontakt];
        } else {
          this.verantwortlicher = [{ name: this.$t("global.notlinked") }];
        }

        data.status = this.stati.find(
          (status) => status.id == this.$CONST("CONFIG").DEFAULTACTIVITYSTATUS
        );

        data.typ = this.typen.find(
          (typ) => typ.id == this.$CONST("CONFIG").DEFAULTACTIVITYTYPE
        );
      } else {
        this.kontaktbasiert =
          !this.aktivitaet.kontaktbasiert && this.leadId !== null
            ? true
            : this.aktivitaet.kontaktbasiert;
        this.verantwortlicher =
          this.aktivitaet?.verantwortlicher?.length == 0
            ? [{ name: this.$t("global.notlinked") }]
            : this.aktivitaet.verantwortlicher;
      }

      this.kontaktPerson = data.neu
        ? this.angemeldeterMitarbeiter.person
        : this.aktivitaet.person;
      this.kontaktFirma = this.aktivitaet.firma;
      this.neueAktivitaet = data.neu ? true : false;
      //this.kontaktbasiert = data.neu ? null : this.aktivitaet.kontaktbasiert;
      this.geplantdatum = data.neu
        ? null
        : this.dateFormatZuYMD(this.aktivitaet.geplantdatum);
      this.effektivdatum = data.neu
        ? null
        : this.dateFormatZuYMD(this.aktivitaet.effektivdatum);
      this.leadId = this.aktivitaet.leadId;

      if (!this.shown) this.openModal();
    });
  },
  methods: {
    replaceLinks,
    // Funktion zum Umwandeln von "YYYY-MM-DD" in "DD.MM.YYYY"
    dateFormatZuDMY(dateStr) {
      if (!dateStr) return null;
      const [year, month, day] = dateStr.split("-");
      return `${day.padStart(2, "0")}.${month.padStart(2, "0")}.${year}`;
    },
    // Funktion zum Umwandeln von "DD.MM.YYYY" in "YYYY-MM-DD"
    dateFormatZuYMD(dateStr) {
      if (!dateStr) return null;
      const [day, month, year] = dateStr.split(".");
      return `${year}-${month.padStart(2, "0")}-${day.padStart(2, "0")}`;
    },
    setPerson(person) {
      this.kontaktPerson = person;
    },

    setJugendlicher(person) {
      this.jugendlicher = person;
    },

    setFirma(firma) {
      this.kontaktFirma = firma;
    },

    setHof(firma) {
      this.hof = firma;
      console.log(this.hof);
    },

    setVerantwortlicher(person) {
      if (person != null || person != undefined) this.verantwortlicher = person;
    },

    setAngebot(angebot) {
      this.angebot = angebot;
      this.einsatzId = null;

      AppApi.get("/einsatzreiter/", {
        params: {
          angebotId: this.angebot.id,
        },
      })
        .then((response) => {
          this.einsaetze = response.data;
        })
        .catch((e) => {
          this.$notify(apiErrorToAlert(e));
        });
    },

    openModal() {
      this.shown = true;

      $("#aktivitaet-bearbeiten-modal").modal({
        backdrop: "static",
        keyboard: false,
      });
    },

    closeModal() {
      this.geplantdatum = null;
      this.effektivdatum = null;
      this.pastDate = false;
      this.pastPlannedDate = false;
      this.kontaktbasiert = null;
      this.kontaktFirma = {};
      this.verantwortlicher = [{ name: this.$t("global.notlinked") }];
      this.hof = {};
      this.jugendlicher = {};
      this.angebot = {};
      this.typ = {};
      this.status = {};
      this.einsatzId = null;
      this.shown = false;
      this.aktivitaet.typ = null;
      this.aktivitaet.status = null;
      this.einsaetze = [];
      $("#aktivitaet-bearbeiten-modal").modal("hide");
    },

    loeschen() {
      if (this.aktivitaet.id) {
        this.$emit("aktivitaetDeleted", this.aktivitaet);
      }
      this.geplantdatum = null;
      this.effektivdatum = null;
      this.schliesseLoeschenModal();
      this.shown = false;
      $("#aktivitaet-bearbeiten-modal").modal("hide");
    },
    schliesseLoeschenModal() {
      $("#pendenzen-loeschen-modal").modal("hide");
    },

    oeffneLoeschenModal() {
      $("#pendenzen-loeschen-modal").modal("show");
    },
    konvertiereDatum(datum) {
      if (!datum) return null;

      const [jahr, monat, tag] = datum.split("-");
      if (this.aktivitaet.geplantzeit) {
        return `${tag}.${monat}.${jahr}`;
      } else {
        return `${tag}.${monat}.${jahr} 00:00`;
      }
    },
    uebernehmen() {
      var aktivitaet = Object.assign({}, this.aktivitaet);
      aktivitaet.person = this.kontaktPerson?.id;
      aktivitaet.firma = this.kontaktFirma?.id;
      aktivitaet.status = this.aktivitaet.status?.id;
      aktivitaet.typ = this.aktivitaet.typ?.id;
      aktivitaet.kontaktbasiert = this.kontaktbasiert;
      aktivitaet.geplantdatum = this.konvertiereDatum(this.geplantdatum);
      aktivitaet.effektivdatum = this.konvertiereDatum(this.effektivdatum);
      aktivitaet.leadId = this.leadId;
      aktivitaet.foreignEntity.firmaId = this.hof?.id;
      aktivitaet.foreignEntity.geschaeftspartnerId = this.jugendlicher?.id;
      aktivitaet.foreignEntity.einsatzId = this.einsatzId;
      aktivitaet.beschreibung = this.verlinkteDatensaetze
        ? this.aktivitaet.beschreibung
          ? `${this.verlinkteDatensaetze}\n***\n\n${this.aktivitaet.beschreibung}`
          : this.verlinkteDatensaetze
        : this.aktivitaet.beschreibung;

      if (!this.geplantdatum) {
        aktivitaet.geplantzeit = null;
      }

      let listVerant = this.verantwortlicher?.filter(
        (verantwortlicher) =>
          verantwortlicher != null && verantwortlicher != undefined
      );

      aktivitaet.verantwortlicher = listVerant?.map(
        (verantwortlicher) => verantwortlicher.id
      );

      if (this.neueAktivitaet) {
        this.$emit("aktivitaetCreated", aktivitaet);
      } else {
        this.$emit("aktivitaetChanged", aktivitaet);
        this.closeModal();
      }
    },
    unsetKontaktbasiert() {
      this.kontaktbasiert = false;
      this.kontaktFirma = {};
      this.verantwortlicher = undefined;
    },
    setKontaktbasiert() {
      this.kontaktbasiert = true;
    },
    unsetAuswahl() {
      this.kontaktbasiert = null;
    },
    //prüft ob das Geplantdatum vor dem heutigen ist
    checkAktDatum() {
      if (!this.geplantdatum) return (this.pastDate = false);

      const today = new Date().toISOString().slice(0, 10);
      if (this.geplantdatum < today) {
        this.pastDate = true;
      } else {
        this.pastDate = false;
      }
    },
    //prüft ob das Effektivdatum vor dem geplantem ist
    checkGeplantdatum() {
      if (!this.effektivdatum) return (this.pastPlannedDate = false);

      if (this.effektivdatum < this.geplantdatum) {
        this.pastPlannedDate = true;
      } else {
        this.pastPlannedDate = false;
      }
    },
    updateDokumentenliste() {
      this.componentKey++;
    },
  },
};
</script>
<style scoped>
/* Scoped Style, da die Paddings der .col-* ansonsten von den Tiles der Startseite ueberschrieben werden */
[class^="col-"],
[class*="col-"] {
  padding-right: 15px !important;
  padding-left: 15px !important;
}
</style>

<style>
td a {
  color: blue;
}
td a:hover {
  text-decoration: underline;
}
</style>
